<template>
    <v-container>
        <v-row no-gutters>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <h1>Party Ledger</h1>
            </v-col>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <v-switch
                v-model="gmwswitch"
                color="red"
                label="GMW"
                hide-details
                ></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            
        </v-row>
        <v-row>
            <v-col cols="12" sm="5">
                <v-autocomplete
                    label="Party Name"
                    v-model="partyname"
                    :items="parties"
                    item-title="partydetails"
                    item-value="parties_partyname"
                    density="default"
                    placeholder="Party name"
                    auto-select-first
                    item-props
                    clearable  
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2">
                <v-text-field label="Start Date" v-model="startdate" type='date' required></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
                <v-text-field label="End Date" v-model="enddate" type='date' required></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-btn color="purple" @click="getledger()" >
                            GET LEDGER
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
    import ShowError from '@/components/Showerror'
    import { useAuthStore } from '@/stores/AuthStore'
    import PartyService from '@/services/PartyService'
    import GSTService from '@/services/GstService'
    import BillService from '@/services/BillService'
    import ReportService from '@/services/ReportService'
    import PurchaseService from '@/services/PurchaseService'
    import GSTR1 from '@/views/gst/gstr1'
    import GSTR3B from '@/views/gst/gstr3b'
    import moment from 'moment';

    const authStore = useAuthStore()
    var gmwswitch = ref(authStore.gmswitch)

    var startdate = ref('')
    var enddate = ref('')
    var partyname = ref('')
    var parties = ref([])
    var partiesgm = ref([])
    var partiesgmw = ref([])

    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    async function getledger(){
        //console.log("Partyname is "+partyname.value)
        //console.log("Start Date is "+startdate.value)
        //console.log("End Date is "+enddate.value)
        var response = gmwswitch.value ?(await ReportService.getledgergmw(partyname.value,startdate.value,enddate.value)) : (await ReportService.getledgergm(partyname.value,startdate.value,enddate.value))
        // //console.log(response)
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //link.download = 'test.pdf'
        window.open(link, '_blank').focus();
    }

    async function getgmparties(){
        try{
            var parties = (await PartyService.getall()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        partiesgm.value = parties
        return parties
    }

    async function getgmwparties(){
        try{
            var parties = (await PartyService.getallgmw()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        partiesgmw.value = parties
        return parties
    }

    onBeforeMount(async () => {
        var gmparties = await getgmparties()
        var gmwparties = await getgmwparties()
        
        parties.value = (gmwswitch.value) ? gmwparties : gmparties
        
    })

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        //parties.value = (gmwswitch.value) ? partiesgmw : partiesgm
    })

</script>